import SearchModel from'./SearchModel';
class KanModel {
    id           = -1
    shifrKan				= "";
    lineKan					= "";
	dateComingsKan			= "";
	dateBeginKan			= "";
	dateEndKan				= "";
	addressKan				= "";
	jobKan					= "";
	descKan					= "";
    infoKan 				= "";
    searchModel = null;
}

export default KanModel